<template>
  <div class="container-fluid homescreen-ct">
    <div class="row justify-content-center error-ct hcol-9 pt-5">
        <div class="text-center align-items-center pt-5">
            <h1 class="text-yellow">Iekārtas uzstādīšana</h1>
            <h3>Norādiet iekārtas PIN</h3>
            <div class="form-group form-group-labeled mb-3  mx-0 pin-input">
              <input v-model="pin"
                      id="pin"
                      @keydown.enter.prevent="confirmPin()"
                      ref="firstInput"
                      type="text" class="form-control pin-input-field">
              <label class="active" for="pin">Ievadiet PIN</label>
            </div>
            <a class="btn mt-5 py-3 btn-warning pin-submit" :class="pin ? '' : 'disabled'" href="#" @click="confirmPin($event)">Apstiprināt</a>
        </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {
  },
  props: [
  ],
  data () {
    return {
      pin: ''
    }
  },
  mounted () {
    this.$refs.firstInput.focus();
  },
  created () {
  },
  computed: {
  },
  methods: {
    confirmPin(e) {
      e.preventDefault();
      this.$emit('sendPin', this.pin);
    }
  },
  watch: {
  }
}
</script>

<style scoped lang="scss">
.pin-submit {
  min-width: 20rem;
  margin-top: 3rem;
}
.pin-input {
  margin-top: 2rem;
  min-width: 20rem;
}
.pin-input-field {
  font-size: 1.5rem;
}
</style>